/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListAssetIncidentsMetaDto
 */
export interface ListAssetIncidentsMetaDto {
    /**
     * Total items across all pages
     * @type {number}
     * @memberof ListAssetIncidentsMetaDto
     */
    total: number;
    /**
     * Current page number
     * @type {number}
     * @memberof ListAssetIncidentsMetaDto
     */
    page: number;
    /**
     * Items per page
     * @type {number}
     * @memberof ListAssetIncidentsMetaDto
     */
    limit: number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof ListAssetIncidentsMetaDto
     */
    totalPages: number;
    /**
     * Open incidents linked to the asset (all pages)
     * @type {number}
     * @memberof ListAssetIncidentsMetaDto
     */
    openCount: number;
    /**
     * Incidents with HIGH or CRITICAL priority linked to the asset (all pages)
     * @type {number}
     * @memberof ListAssetIncidentsMetaDto
     */
    highPriorityCount: number;
    /**
     * Newest createdAt among incidents linked to the asset
     * @type {Date}
     * @memberof ListAssetIncidentsMetaDto
     */
    latestCreatedAt?: Date | null;
}

/**
 * Check if a given object implements the ListAssetIncidentsMetaDto interface.
 */
export function instanceOfListAssetIncidentsMetaDto(value: object): value is ListAssetIncidentsMetaDto {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('openCount' in value) || value['openCount'] === undefined) return false;
    if (!('highPriorityCount' in value) || value['highPriorityCount'] === undefined) return false;
    return true;
}

export function ListAssetIncidentsMetaDtoFromJSON(json: any): ListAssetIncidentsMetaDto {
    return ListAssetIncidentsMetaDtoFromJSONTyped(json, false);
}

export function ListAssetIncidentsMetaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetIncidentsMetaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'totalPages': json['totalPages'],
        'openCount': json['openCount'],
        'highPriorityCount': json['highPriorityCount'],
        'latestCreatedAt': json['latestCreatedAt'] == null ? undefined : (new Date(json['latestCreatedAt'])),
    };
}

export function ListAssetIncidentsMetaDtoToJSON(json: any): ListAssetIncidentsMetaDto {
    return ListAssetIncidentsMetaDtoToJSONTyped(json, false);
}

export function ListAssetIncidentsMetaDtoToJSONTyped(value?: ListAssetIncidentsMetaDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'totalPages': value['totalPages'],
        'openCount': value['openCount'],
        'highPriorityCount': value['highPriorityCount'],
        'latestCreatedAt': value['latestCreatedAt'] == null ? value['latestCreatedAt'] : value['latestCreatedAt'].toISOString(),
    };
}

